const config = {
    host: (process.env.NODE_ENV === 'production') ? 'https://ruleteandomex.dvgeo.app' : 'http://192.168.100.106:3013',
    homePage: (process.env.NODE_ENV === 'production') ? 'https://ruleteandomex.dvgeo.app' : 'http://192.168.100.106:3013',
    api: 'api/',
    apiSocket: 'ruleteandomex::1.2',
    nameDir: 'ruleteandomex',
    package: 'app.dvgeo.ruleteandomex.web',
    version: '1.0.0',
    googleAPIKey: 'AIzaSyCiQ9Y-9rQXNyakiFPCcZzT59l5dcIjVvU',
    appName: 'RULETEANDOMEX',
    provider: 'Devjos CIA LTDA',
    colorPrimary: '#fdaa02',
    colorDark: '#000000',
    colorAccent: '#ccc',
    colorTextPrimary: '#fff',
    colorTextDark: '#000',
    playStorePassengerId: 'app.dvgeo.ruleteandomex.passenger',
    playStoreDriverId: 'app.dvgeo.ruleteandomex.driver',
    appStorePassengerId: '6787271586',
    appStoreDriverId: '6787271363',
};
export default config;
